export const EMISSION_DAY = 86400n;
export const EMISSION_TOTAL_DAYS = 1908n;
export const MINING_ALLOCATION = 950000000n * 10n ** 18n;
const WEIGHTED_DURATION = 7808n * EMISSION_DAY;
const STAGES = [
    { duration: 3n * EMISSION_DAY, weight: 256n },
    { duration: 5n * EMISSION_DAY, weight: 128n },
    { duration: 10n * EMISSION_DAY, weight: 64n },
    { duration: 30n * EMISSION_DAY, weight: 32n },
    { duration: 60n * EMISSION_DAY, weight: 16n },
    { duration: 120n * EMISSION_DAY, weight: 8n },
    { duration: 240n * EMISSION_DAY, weight: 4n },
    { duration: 480n * EMISSION_DAY, weight: 2n },
    { duration: 960n * EMISSION_DAY, weight: 1n },
];
export function cumulativeEmission(emissionStart, timestamp) {
    if (emissionStart === 0n || timestamp <= emissionStart)
        return 0n;
    let remaining = timestamp - emissionStart;
    if (remaining >= EMISSION_TOTAL_DAYS * EMISSION_DAY)
        return MINING_ALLOCATION;
    let weightedElapsed = 0n;
    for (const stage of STAGES) {
        const elapsed = remaining < stage.duration ? remaining : stage.duration;
        weightedElapsed += elapsed * stage.weight;
        if (remaining <= stage.duration)
            break;
        remaining -= stage.duration;
    }
    return (MINING_ALLOCATION * weightedElapsed) / WEIGHTED_DURATION;
}
export function cumulativeVerifiedEmission(emissionStart, timestamp) {
    return (cumulativeEmission(emissionStart, timestamp) * 99n) / 100n;
}
export function emissionBetween(emissionStart, fromTime, toTime) {
    if (toTime <= fromTime)
        return { total: 0n, verified: 0n, unverified: 0n };
    const fromTotal = cumulativeEmission(emissionStart, fromTime);
    const toTotal = cumulativeEmission(emissionStart, toTime);
    const total = toTotal - fromTotal;
    const verified = cumulativeVerifiedEmission(emissionStart, toTime) -
        cumulativeVerifiedEmission(emissionStart, fromTime);
    return { total, verified, unverified: total - verified };
}
//# sourceMappingURL=emission.js.map